import { Dialog } from "primereact/dialog";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { Checkbox } from "primereact/checkbox";
import { ISignatureMast } from "../../models/SignatureMast";
import { Dropdown } from "primereact/dropdown";
import { IEmailTempDropdown } from "../../models/IDropdown";
import { IEmailTemplate } from "../../models/EmailTemplate";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const schema = yup.object({
    subject: yup.string().required("subject is required")
});

interface IProps {
    data: Array<{ contactPersonID: number, contactPersonName: string, contactPersonEmail: string }>
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

interface IMail {
    clients: Array<{ client_ID: number, client_Email: string }>
    subject: string,
    emailBody: string,
    is_Short: boolean,
    signature: string
}

export const Mail = ({ data, open, hideDialog, toast, reload, setReload }: IProps) => {
    const [emailTemplates, setEmailTemplates] = useState<Array<IEmailTempDropdown>>();
    const [etId, setEtId] = useState(0);
    const [body, setBody] = useState("");
    const [signature, setSignature] = useState({ val: "", disabled: true });
    const [signatureDetails, setSignatureDetails] = useState<ISignatureMast>({});
    const [isShort, setIsShort] = useState(false);

    const { control, handleSubmit, formState: { errors }, reset, setValue } = useForm<IMail>({
        resolver: yupResolver(schema),
        defaultValues: {
            subject: '',
            emailBody: '',
            is_Short: false,
            signature: ''
        }
    });

    const loadSignature = async () => {
        const response = await Fetch("Signature_Mast", "GET", null, null, null);
        if (response) {
            const data: ISignatureMast = await response.json();
            setSignatureDetails(data);
            if (data.signature) setSignature({ val: data.signature, disabled: signature.disabled });
        }
    }

    const loadEmailTemplates = async () => {
        const response = await Fetch("DropDown/emailTemplate", "GET", null, null, toast);
        if (response) {
            const data: Array<IEmailTempDropdown> = await response.json();
            setEmailTemplates(data);
        }
    }

    const fillEmailTemplate = async () => {
        const response = await Fetch("Email_Template/byId", "GET", null, `id=${etId}`, toast);
        if (response) {
            const data: IEmailTemplate = await response.json();
            if (data.template_Subject) setValue("subject", data.template_Subject);
            if (data.template_Body) setBody(data.template_Body);
        }
    }

    useEffect(() => {
        loadSignature();
        loadEmailTemplates();
    }, []);
    useEffect(() => {
        if (etId) fillEmailTemplate();
    }, [etId]);

    useEffect(() => {
        if (isShort) {
            if (signatureDetails.short_Signature) setSignature({ val: signatureDetails.short_Signature, disabled: signature.disabled });
            else setSignature({ val: "", disabled: signature.disabled });
        } else {
            if (signatureDetails.signature) setSignature({ val: signatureDetails.signature, disabled: signature.disabled });
            else setSignature({ val: "", disabled: signature.disabled });
        }
    }, [isShort]);

    const sendMail = async (fbody: IMail) => {
        fbody.is_Short = isShort;
        fbody.signature = signature.val;
        fbody.emailBody = body;

        const _clients: Array<{ client_ID: number, client_Email: string }> = [];
        data.forEach(d => {
            const client: { client_ID: number, client_Email: string } = {
                client_ID: d.contactPersonID,
                client_Email: d.contactPersonEmail
            }
            _clients.push(client);
        });
        fbody.clients = _clients;
        const response = await Fetch("Email_Template/sendEmailToContactPersons", "POST", fbody, null, toast);
        if (response) {
            onHide();
            setReload(!reload);
            toast.current.show({ severity: 'success', detail: "Mail Distributed Successfully.", life: 3000 });
        }
    }

    function onSubmit(data: IMail) {
        if (body.length < 1) toast.current.show({ severity: 'error', detail: "Mail Body is Required.", life: 3000 });
        else if (signature.val.length < 1) toast.current.show({ severity: 'error', detail: "Signature is Required.", life: 3000 });
        else sendMail(data);
    }

    const onHide = () => {
        hideDialog(); reset({ subject: "" }); setBody(""); setEtId(0);
        setSignature({ val: signature.val, disabled: true });
    }

    const header = () => {
        return <span>Send Mail To - {data.map((d, i) => {
            return <span key={d.contactPersonID}>{d.contactPersonName}{i < data.length - 1 && ","} </span>
        })}</span>
    }

    return (
        <Dialog visible={open} style={{ width: '80vw' }} header={header} className="p-fluid" onHide={onHide} draggable={false}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

                <div className="field col-12 md:col-6">
                    <Dropdown options={emailTemplates} optionValue={"template_Id"} optionLabel={"template_Name"} value={etId} onChange={e => setEtId(e.value)} placeholder="Choose Email Template" />
                </div>

                <JVInput column={1} label="Subject" control={control} name="subject" error={errors.subject?.message} />
                <div className="col-12 md:col-12 md:col-6 mb-3">
                    <label>Body</label>
                    <CKEditor editor={ClassicEditor} data={body} onChange={(event, editor) => { setBody(editor.getData()); }} />
                </div>

                <div className="col-12 md:col-12 md:col-6">
                    <div style={{ display: 'flex', justifyContent: "space-between", alignItems: "flex-end" }}>
                        <label>Signature</label>
                        <div className="field-checkbox m-1">
                            {signature.disabled ? <Button type="button" icon="pi pi-pencil" className="p-button-rounded p-button-text" onClick={() => setSignature({ val: signature.val, disabled: false })} />
                                : <Button type="button" icon="pi pi-ban" className="p-button-rounded p-button-text" onClick={() => setSignature({ val: signature.val, disabled: true })} />}
                            <label className="mr-1" htmlFor="binary">Short Sign</label>
                            <Checkbox inputId="binary" checked={isShort} onChange={e => setIsShort(e.checked)} />
                        </div>
                    </div>
                    <CKEditor editor={ClassicEditor} data={signature.val} onChange={(event, editor) => { setSignature({ val: editor.getData(), disabled: signature.disabled }); }} disabled={signature.disabled} />
                </div>

                <div className="col-12 md:col-12 mt-3">
                    <Button className="field col-12 md:col-6" label="SEND" type="submit"></Button>
                </div>
            </form>
        </Dialog>
    );
}